import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion'

export function FaqSection() {
  const faqs = [
    {
      q: 'Puis-je essayer gratuitement ?',
      a: 'Oui, vous pouvez créer un compte et tester immédiatement, sans carte bancaire.',
    },
    {
      q: 'Mes données sont-elles sécurisées ?',
      a: 'Oui. Sauvegardes automatiques, connexion sécurisée, et droits par rôle.',
    },
    {
      q: 'Puis-je importer mes articles ?',
      a: 'Oui, via un import CSV (SKU, nom, prix, stock, etc.).',
    },
    {
      q: 'Support ?',
      a: 'Chat et email, avec réponses rapides en heures ouvrées.',
    },
    {
      q: 'Est-ce que MOGESAPP est fait seulement pour le stock ?',
      a: 'Non. Le stock est important, mais le cœur du produit aujourd’hui est plus large : clients, factures, paiements, créances, dépenses, relances et pilotage d’activité.',
    },
    {
      q: 'Puis-je commencer sans tout configurer ?',
      a: 'Oui. Le plus simple est de démarrer avec un dépôt principal, quelques produits, quelques clients, puis commencer à facturer. Tu peux structurer davantage ensuite.',
    },
    {
      q: 'Dois-je obligatoirement utiliser les catégories ?',
      a: 'Non. Elles sont optionnelles. Mais elles deviennent vite utiles pour filtrer ton catalogue, analyser tes ventes et garder une base propre.',
    },
    {
      q: 'Quelle différence entre paiement, avoir et dépôt non affecté ?',
      a: 'Un paiement règle une facture. Un dépôt non affecté est une somme enregistrée sans facture précise. Un avoir est un crédit disponible qui peut être utilisé plus tard ou remboursé selon le cas.',
    },
    {
      q: 'Puis-je importer mes clients et mes produits ?',
      a: 'Oui. L’import CSV est prévu pour travailler proprement avec une logique de preview puis commit, afin de vérifier les données avant de les écrire réellement en base.',
    },
    {
      q: 'Les relances partent-elles automatiquement ?',
      a: 'Elles peuvent être manuelles ou automatiques selon les règles configurées. Mais il faut d’abord s’assurer que les coordonnées clients sont propres et que la dette affichée est réellement fiable.',
    },
    {
      q: 'Puis-je utiliser MOGESAPP avec plusieurs utilisateurs ?',
      a: 'Oui. Le produit gère plusieurs rôles, notamment OWNER, ADMIN et STAFF, avec des limites qui dépendent aussi du plan actif.',
    },
    {
      q: 'Le mode hors connexion est-il déjà disponible ?',
      a: 'Pas encore comme fonctionnalité centrale stable. C’est une évolution prévue, mais elle doit venir après stabilisation complète du cœur métier.',
    },
  ]
  return (
    <section className='mx-auto max-w-3xl px-4 py-16'>
      <h2 className='text-3xl font-bold text-center'>Questions fréquentes</h2>
      <Accordion type='single' collapsible className='mt-8'>
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`}>
            <AccordionTrigger>{f.q}</AccordionTrigger>
            <AccordionContent className='text-sm text-muted-foreground'>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  )
}
